module.exports = __webpack_public_path__ + "static/media/puppy.4d2e3104.svg";